export function section09() {
    gsap.to(".section.slice-9 img", {
        y: "-200px",
        duration: 2,
        ease: "Power1.easeOut",
        scrollTrigger: {
            trigger: ".section.slice-9",
            start: "center bottom",
            end: "bottom 5%",
            scrub: 1,
        },
    })
}
